




























































































































































































import { CrudService } from "../core/services/crudService";
import { Settings, SettingsService, TenantSettings } from "../core/services/configService";
import Vue from "vue";
import Component from "vue-class-component";
import { LocalStorage } from "../core/localStorage";
import { Format } from "../core/helpers/formatHelper";
import { ShopService } from "../core/services/shopService";
import { SortType } from "../core/constants";
import store from "../core/store";
import { Watch } from "vue-property-decorator";
import SearchBar from "../components/listings/SearchBar.vue";
import FilterPanel from "../components/listings/FilterPanel.vue";
import ListingTopPanel from "../components/listings/ListingTopPanel.vue";
import CtaButton from "../components/ctaButton/ctaButton.vue";
import SectionPagination from "../components/pagination/SectionPagination.vue";

@Component({
  components: {
    CtaButton,
    SearchBar,
    FilterPanel,
    ListingTopPanel,
    SectionPagination,
  },
})
export default class ShopPage extends Vue {
  settings: TenantSettings = {};
  products: any = null;
  popular: any = null;
  productTypes: any = null;
  error: string = "";
  ok: string = "";
  productTypeId: number | null = null;
  search: string = "";
  sort: any[] = [];
  sortType: SortType = SortType.ByNew;
  firstRecord: number = 0;
  lastRecord: number = 0;
  pageSize: number = 30;
  totalCount: number = 0;
  currentPage: number = 1;

  get resultsLabel() {
    return (
      this.$t("Showing") +
      " " +
      (this.firstRecord + 1) +
      "–" +
      this.lastRecord +
      " " +
      this.$t("of") +
      " " +
      this.totalCount +
      " " +
      this.$t("results")
    );
  }

  get totalPages() {
    if (!this.totalCount) {
      return 1;
    }
    return Math.max(1, Math.ceil(this.totalCount / this.pageSize));
  }
  reloadShop: number = 0;

  async mounted() {
    new SettingsService().setPageTitle(String(this.$t("Shop")));
    this.settings = store.state.settings;
    this.sort = [
      { value: 1, label: this.$t("Sort By New") },
      { value: 2, label: this.$t("Sort By Price Ascending") },
      { value: 3, label: this.$t("Sort By Price Descending") },
    ];
    this.currentPage = 1;
    this.lastRecord = this.pageSize;

    let initialSearch =
      this.$route.query === undefined || this.$route.query.search === undefined
        ? null
        : this.$route.query.search;

    await this.loadData(initialSearch);
  }

  async loadData(initialSearch: any = null) {
    let cid = null;
    let sid = LocalStorage.getWithTimeout("cc");
    if (sid !== undefined && sid !== null) {
      cid = JSON.parse(sid).id;
    }

    let filters: any = {};
    let productTypeFilter: any = {};
    let searchFilter: any = {};
    let sort: any = [];

    if (this.productTypeId !== null) {
      productTypeFilter["ProductTypeId"] = {
        type: "equals",
        filter: this.productTypeId,
        filterType: "number",
      };

      filters = Object.assign(filters, productTypeFilter);
    }

    if (this.sortType !== null) {
      switch (Number(this.sortType)) {
        case SortType.ByNew:
          sort = [{ colId: "Created", sort: "desc" }];
          break;
        case SortType.ByPriceAsc:
          sort = [{ colId: "GrossPrice", sort: "asc" }];
          break;
        case SortType.ByPriceDesc:
          sort = [{ colId: "GrossPrice", sort: "desc" }];
          break;
      }
    }

    this.search =
      initialSearch !== null && initialSearch !== undefined
        ? initialSearch
        : this.search;
    if (this.search !== null && this.search !== "") {
      searchFilter["Name"] = {
        condition1: {
          type: "contains",
          filter: this.search,
          filterType: "text",
        },
        condition2: {
          secondField: "Detail",
          type: "contains",
          filter: this.search,
          filterType: "text",
        },
        condition3: {
          secondField: "Description",
          type: "contains",
          filter: this.search,
          filterType: "text",
        },
        operator: "OR",
      };

      filters = Object.assign(filters, searchFilter);
    }

    let gridStatus = encodeURIComponent(
      JSON.stringify({ filters: filters, sort: sort })
    );

    let url =
      cid == null
        ? `${Settings.HostName}/api/shop/list?startRow=${this.firstRecord}&endRow=${this.lastRecord}&gridStatus=${gridStatus}`
        : `${Settings.HostName}/api/shop/list-by-customer?customerId=${cid}&startRow=${this.firstRecord}&endRow=${this.lastRecord}&gridStatus=${gridStatus}`;
    let data = await new CrudService().httpGet(url);

    if (data == null || data === undefined || data.ok === false) {
      console.error("Crash getting shop " + cid);
      return;
    }

    this.products = data.data;
    this.popular = data.popular;
    this.productTypes = data.productTypes;
    this.totalCount = data.totalCount;
    if (this.totalCount > 0 && this.currentPage > this.totalPages) {
      await this.setPage(this.totalPages);
      return;
    }
    if (this.lastRecord >= this.totalCount) {
      this.lastRecord = this.totalCount;
    }
    window.scrollTo(0, 0);
  }

  async setPage(page: number) {
    const safePage = Math.min(Math.max(page, 1), this.totalPages);
    this.currentPage = safePage;
    this.firstRecord = (safePage - 1) * this.pageSize;
    this.lastRecord = this.firstRecord + this.pageSize;
    await this.loadData();
  }

  goNextPage() {
    if (this.currentPage >= this.totalPages) return;
    this.setPage(this.currentPage + 1);
  }

  goToPage(page: number) {
    if (page === this.currentPage) return;
    this.setPage(page);
  }

  goPrevPage() {
    if (this.currentPage <= 1) return;
    this.setPage(this.currentPage - 1);
  }

  getImagePath(img: string) {
    if (img === null || img === undefined || img === "") {
      return this.settings.Uploads + "/" + this.settings.Mainlogo;
    }
    return this.settings.Uploads + "/" + img;
  }

  formatPrice(price: string) {
    return Format.formatCurrency(price);
  }

  async addToCart(p: any, e: any) {
    e.preventDefault();
    await new ShopService().addProductToCart(p, 1, e.currentTarget);
  }

  async selectProductType(id: number | null) {
    this.productTypeId = id;
    await this.setPage(1);
  }

  async selectSort() {
    await this.setPage(1);
  }

  async selectSearch() {
    if (this.search === "" || this.search.length > 3) {
      await this.setPage(1);
    }
  }

  @Watch("$route.query.search")
  async reload() {
    new SettingsService().setPageTitle(String(this.$t("Shop")));
    let initialSearch =
      this.$route.query === undefined || this.$route.query.search === undefined
        ? null
        : this.$route.query.search;
    this.currentPage = 1;
    this.firstRecord = 0;
    this.lastRecord = this.pageSize;
    await this.loadData(initialSearch);
    this.reloadShop++;
  }

  isLoggedIn() {
    const t = LocalStorage.getWithTimeout("ctk");
    return t !== undefined && t !== null && t !== "";
  }

  login() {
    store.commit("openLogin", { backUrl: window.location.pathname });
  }
}
